<template>
  <div class="bg2">
    <!-- <Header title="退款/退货" background="#ffffff"></Header> -->
    <div class="goodsDetial">
      <h5>商品详情</h5>
      <p class="line"></p>
      <div class="list flex-center">
        <img src="../../assets/my/pic@2x (1).png" alt="" />
        <div class="orderMsg">
          <p>女生卫衣连帽拼接款</p>
          <p>4299日元(267.19人民币)</p>
        </div>
      </div>
    </div>
    <div class="box">
      <div class="select flex-between" @click="goUrl('/my/tuiDetial')">
        <div class="flex-between">
          <img
            class="selectLeft"
            src="../../assets/my/refund_icon_small@2x.png"
            alt=""
          />
          <div>
            <p>退款</p>
            <p>未收到货（包含未签收），或卖家协商同意前提下</p>
          </div>
        </div>
        <img class="right" src="../../assets/my/more@2x (2).png" alt="" />
      </div>
      <!-- <div class="select flex-between" @click="goUrl('/my/tuiDetial2')">
        <div class="flex-between">
          <img
            class="selectLeft"
            src="../../assets/my/return_icon_small@2x.png"
            alt=""
          />
          <div>
            <p>退货退款</p>
            <p>已收到货，需要退还已收到的货物</p>
          </div>
        </div>
        <img class="right" src="../../assets/my/more@2x (2).png" alt="" />
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {};
  },
  computed: {},
  methods: {
    goUrl(url) {
      this.$router.push(url);
    },
  },
};
</script>

<style lang='less' scoped>
.line {
  height: 2px;
  background: linear-gradient(90deg, #fd0212 0%, #ffffff 100%);
  opacity: 0.3;
}
.goodsDetial {
  background: #ffffff;
  box-shadow: 0px 6px 20px 0px rgba(16, 16, 16, 0.04);
  border-radius: 12px;
  padding-bottom: 30px;
  margin-top: 14px;
  h5 {
    height: 50px;
    padding-left: 15px;
    line-height: 50px;
    font-size: 16px;
  }

  .list {
    padding-top: 16px;
    padding-left: 16px;
    img {
      width: 88px;
      height: 82px;
      margin-right: 10px;
    }
    .orderMsg {
      height: 70px;
      padding-bottom: 10px;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      color: #303133;
      font-size: 14px;
      border-bottom: 1px solid #f0f0f0;
      p:nth-child(2) {
        font-size: 13px;
        color: #fd0212;
      }
    }
  }
}
.box {
  margin-top: 14px;
  background: #ffffff;
  box-shadow: 0px 6px 20px 0px rgba(16, 16, 16, 0.04);
  border-radius: 12px;
}
.select {
  padding: 0 15px;
  height: 55px;
  border-bottom: 1px solid #e5e5ea;
  .selectLeft {
    width: 28px;
    height: 28px;
    margin-right: 10px;
  }
  div {
    font-size: 12px;
    color: #666666;
    p:nth-child(2) {
      color: #999999;
    }
  }
  .right {
    width: 18px;
    height: 18px;
  }
}
</style>
